import { NotificationMessageType } from '@/api/apis/communication';

export const successLabels = {
  [NotificationMessageType.CaseBulkSwapOperationCompleted]: 'Successfully swapped',
  [NotificationMessageType.CaseBulkAssignOperationCompleted]: 'Successfully assigned',
  [NotificationMessageType.CaseBulkDetachOperationCompleted]: 'Successfully detached',
  [NotificationMessageType.CaseBulkOperationPrimaryElevation]: 'Successfully changed primary',
};

export const failureLabels = {
  [NotificationMessageType.CaseBulkSwapOperationCompleted]: 'Failed to swap',
  [NotificationMessageType.CaseBulkAssignOperationCompleted]: 'Failed to assign',
  [NotificationMessageType.CaseBulkDetachOperationCompleted]: 'Failed to detach',
  [NotificationMessageType.CaseBulkOperationPrimaryElevation]: 'Failed to change primary',
};

export const organContradictionLabels = {
  [NotificationMessageType.CaseBulkSwapOperationCompleted]:
    'Failed to swap because the user’s organ certifications contradict the organ types of the following case(s)',
  [NotificationMessageType.CaseBulkAssignOperationCompleted]:
    'Failed to assign because the user’s organ certifications contradict the organ types of the following case(s)',
  [NotificationMessageType.CaseBulkDetachOperationCompleted]: '',
  [NotificationMessageType.CaseBulkOperationPrimaryElevation]: '',
};
